import { createSlice } from "@reduxjs/toolkit";

const applyDirection = (language) => {
  if (typeof window === "undefined") {
    return;
  }

  const direction = language === "ar" ? "rtl" : "ltr";

  document.documentElement.setAttribute("dir", direction);
  document.documentElement.setAttribute("lang", language || "en");
};

const persistLocaleCookie = (language) => {
  if (typeof document === "undefined") {
    return;
  }

  document.cookie = `app_locale=${language}; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=Lax`;
};

export const LanguageSlice = createSlice({
  name: "language",
  initialState: { language: "ar" },
  reducers: {
    setLanguage: (state, action) => {
      const nextLanguage = action.payload || "ar";
      state.language = nextLanguage;

      if (typeof window !== "undefined") {
        localStorage.setItem("appLanguage", nextLanguage);
        persistLocaleCookie(nextLanguage);
      }

      applyDirection(nextLanguage);
    },
    loadLanguage: (state) => {
      if (typeof window !== "undefined") {
        const stored = localStorage.getItem("appLanguage");

        if (stored === "en" || stored === "ar") {
          state.language = stored;
          persistLocaleCookie(stored);
        }
      }

      applyDirection(state.language);
    },
  },
});

export default LanguageSlice.reducer;

export const { setLanguage, loadLanguage } = LanguageSlice.actions;
